import guid from '../newGuid';
import PersistentCookie from '../persistentCookie';
import api from '../callApi';
import config from '../../config';

const CookieName = 'ActionButton_Widget_CustomClientId';

function getClientId(allowSameOrigin) {
    var cookie = new PersistentCookie(allowSameOrigin);

    return cookie
        .get(CookieName)
        .then(value => {
            if (!value) {
                return api
                    .post(
                        config.USER_API_BASE_URL + 'user/getId',
                        {},
                        { useFingerprint: true }
                    )
                    .then(newClientId => {
                        cookie.set(CookieName, newClientId);
                        return newClientId;
                    });
            }
            return value;
        })
        .catch(() => {
            const newClientId = guid();
            cookie.set(CookieName, newClientId);
            return newClientId;
        });
}

export default getClientId;
